export const RECEIVED_POSTS = "RECEIVED_POSTS"
export const LOADING_POSTS = "LOADING_POSTS"
export const SET_SORT = "SET_SORT"
export const DELETING_POSTS = "DELETING_POSTS"
export const UPDATE_POST = "UPDATE_POST"



// WEBPACK FOOTER //
// ./src/types/actions/posts.js